(()=>{
'use strict';
const reduce=matchMedia('(prefers-reduced-motion: reduce)');
// Mode capacities and hit values: seller-published product infographic, references/image-10.png.
const modes=[
 {id:'mode-single',title:'Single shot',kicker:'MAKE EVERY TAG COUNT',copy:'9 shots before reloading. Each successful tag removes 1 life.',shots:9,lives:1,color:'#40caff'},
 {id:'mode-machine',title:'Machine gun',kicker:'DOUBLE THE HIT',copy:'6 shots per load. Each successful tag removes 2 lives.',shots:6,lives:2,color:'#c1ff3b'},
 {id:'mode-laser',title:'Laser gun',kicker:'PICK YOUR MOMENT',copy:'6 shots before reloading. Land a tag to take 2 lives.',shots:6,lives:2,color:'#ffe66c'},
 {id:'mode-plasma',title:'Plasma gun',kicker:'MAKE YOUR SHOT COUNT',copy:'1 shot. A successful tag removes 3 lives. Reload for your next shot.',shots:1,lives:3,color:'#ff657f'}
];
let io;
function reveal(scope){
 if(reduce.matches||!('IntersectionObserver' in window))return;
 document.body.classList.add('motion-enabled');
 if(!io)io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}}),{threshold:.07});
 scope.querySelectorAll('.reveal').forEach(e=>io.observe(e));
}
function init(scope=document){
 reveal(scope);
 scope.querySelectorAll('[data-cart-upgrade]').forEach(form=>{if(form.dataset.ready)return;form.dataset.ready='true';form.addEventListener('submit',async e=>{e.preventDefault();const button=form.querySelector('button'),error=form.querySelector('[role=status]');button.disabled=true;error.textContent='';try{const response=await fetch(form.action+'.js',{method:'POST',body:new FormData(form)});const data=await response.json();if(!response.ok)throw new Error(data.description||'This upgrade is currently unavailable. Please try again.');location.href=form.querySelector('[name=return_to]').value}catch(err){error.textContent=err.message;button.disabled=false}})});

 scope.querySelectorAll('[data-glow-toggle]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='true';button.addEventListener('click',()=>{const on=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(on));button.querySelector('span').textContent=on?'LIGHTS ON · TAP TO RESET':'TURN ON THE GLOW';const v=button.closest('.gear-grid').querySelector('[data-glow-state]');v.dataset.glowState=on?'on':'off';v.querySelector('[data-glow-caption]').textContent=on?'LIGHTS ON':'LIGHTS OFF'})});
 scope.querySelectorAll('[data-product]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const image=root.querySelector('[data-main-image]'),caption=root.querySelector('[data-image-caption]');
  const photos=[...root.querySelectorAll('[data-photo]')],thumbs=root.querySelector('.gallery-thumbs');
  const stage=root.querySelector('.gallery-stage');
  let track=null,scrollTimer,mouseDrag=null;
  let photoIndex=Math.max(0,photos.findIndex(button=>button.getAttribute('aria-pressed')==='true'));
  const revealThumb=button=>{
   if(!thumbs||thumbs.scrollWidth<=thumbs.clientWidth)return;
   const rail=thumbs.getBoundingClientRect(),item=button.getBoundingClientRect();
   const shift=item.left<rail.left?item.left-rail.left:item.right>rail.right?item.right-rail.right:0;
   // Move only the thumbnail rail: scrollIntoView can also scroll the page on older browsers.
   if(Math.abs(shift)>1)thumbs.scrollTo({left:thumbs.scrollLeft+shift,behavior:reduce.matches?'auto':'smooth'});
  };
  const setPhoto=(index,scroll=false)=>{
   if(!photos.length||!image)return;
   photoIndex=((index%photos.length)+photos.length)%photos.length;
   const selected=photos[photoIndex];
   photos.forEach((button,i)=>{button.setAttribute('aria-pressed',String(i===photoIndex));button.tabIndex=i===photoIndex?0:-1});
   if(!track){image.src=selected.dataset.photo;image.alt=selected.dataset.caption||'';}
   if(caption)caption.textContent=selected.dataset.caption||'';
   root.querySelectorAll('[data-gallery-index]').forEach(counter=>counter.textContent=String(photoIndex+1));
   root.querySelectorAll('[data-gallery-total]').forEach(counter=>counter.textContent=String(photos.length));
   if(scroll){
    revealThumb(selected);
    if(track)track.scrollTo({left:photoIndex*track.clientWidth,behavior:reduce.matches?'instant':'smooth'});
   }
  };
  photos.forEach((button,i)=>{
   button.addEventListener('click',()=>setPhoto(i,true));
   button.addEventListener('keydown',event=>{
    let next;
    if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(i+1)%photos.length;
    if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(i-1+photos.length)%photos.length;
    if(event.key==='Home')next=0;
    if(event.key==='End')next=photos.length-1;
    if(next===undefined)return;
    event.preventDefault();setPhoto(next,true);photos[next].focus({preventScroll:true});
   });
  });
  root.querySelectorAll('[data-gallery-prev]').forEach(button=>button.addEventListener('click',()=>setPhoto(photoIndex-1,true)));
  root.querySelectorAll('[data-gallery-next]').forEach(button=>button.addEventListener('click',()=>setPhoto(photoIndex+1,true)));
  setPhoto(photoIndex);
  if(stage&&image&&photos.length>1){
   // Real adjacent slides: touch scrolling and momentum are handled by the browser.
   track=document.createElement('div');
   track.className='gallery-track';
   track.setAttribute('aria-label','Product photos');
   stage.insertBefore(track,image);
   photos.forEach((button,index)=>{
    const slide=index===0?image:document.createElement('img');
    slide.src=button.dataset.photo;slide.alt=button.dataset.caption||'';
    slide.width=image.width;slide.height=image.height;
    slide.draggable=false;slide.decoding='async';
    if(index>1)slide.loading='lazy';
    track.append(slide);
   });
   const syncPosition=()=>{
    if(mouseDrag||!track.clientWidth)return;
    const index=Math.max(0,Math.min(photos.length-1,Math.round(track.scrollLeft/track.clientWidth)));
    track.classList.remove('is-dragging');
    setPhoto(index);revealThumb(photos[index]);
   };
   track.addEventListener('scroll',()=>{
    clearTimeout(scrollTimer);
    scrollTimer=setTimeout(syncPosition,140);
   },{passive:true});
   track.addEventListener('scrollend',()=>{clearTimeout(scrollTimer);syncPosition()});
   track.addEventListener('dragstart',event=>event.preventDefault());
   const endDrag=cancel=>{
    if(!mouseDrag)return;
    const drag=mouseDrag;mouseDrag=null;
    const width=track.clientWidth;
    let next=Math.round(track.scrollLeft/width);
    if(!cancel&&Math.abs(drag.dx)>Math.min(65,width*.18))next=drag.index+(drag.dx<0?1:-1);
    next=Math.max(0,Math.min(photos.length-1,next));
    // Restore snapping only once the smooth scroll finishes, avoiding a snap-back first.
    if(track.hasPointerCapture(drag.id))track.releasePointerCapture(drag.id);
    setPhoto(next,true);
    clearTimeout(scrollTimer);scrollTimer=setTimeout(syncPosition,180);
   };
   track.addEventListener('pointerdown',event=>{
    if(event.pointerType!=='mouse'||event.button!==0)return;
    clearTimeout(scrollTimer);
    mouseDrag={id:event.pointerId,x:event.clientX,y:event.clientY,left:track.scrollLeft,index:Math.round(track.scrollLeft/track.clientWidth),dx:0,locked:false};
    track.setPointerCapture(event.pointerId);
   });
   track.addEventListener('pointermove',event=>{
    if(!mouseDrag||event.pointerId!==mouseDrag.id)return;
    const dx=event.clientX-mouseDrag.x,dy=event.clientY-mouseDrag.y;
    if(!mouseDrag.locked){
     if(Math.max(Math.abs(dx),Math.abs(dy))<5)return;
     if(Math.abs(dy)>Math.abs(dx)){endDrag(true);return;}
     mouseDrag.locked=true;track.classList.add('is-dragging');
    }
    mouseDrag.dx=dx;
    track.scrollLeft=mouseDrag.left-dx;
   });
   track.addEventListener('pointerup',event=>{if(mouseDrag&&event.pointerId===mouseDrag.id)endDrag(false)});
   track.addEventListener('pointercancel',()=>endDrag(true));
   track.addEventListener('lostpointercapture',()=>endDrag(true));
   // Keep the active slide aligned when the phone rotates or the layout changes.
   if('ResizeObserver' in window){
    let width=track.clientWidth;
    new ResizeObserver(()=>{
     if(width===track.clientWidth)return;
     width=track.clientWidth;
     track.scrollTo({left:photoIndex*width,behavior:'instant'});
    }).observe(track);
   }
  }
  const update=()=>{
   const chosen=root.querySelector('input[name=id]:checked');if(!chosen)return;
   const disabled=chosen.disabled,price=chosen.dataset.price;
   root.querySelectorAll('[data-button-price]').forEach(e=>e.textContent=price);
   document.querySelectorAll('[data-sticky-price]').forEach(e=>e.textContent=price);
   document.querySelectorAll('[data-sticky-name]').forEach(e=>e.textContent=chosen.dataset.name);
   root.querySelectorAll('[data-battery-count]').forEach(e=>e.textContent=chosen.dataset.batteries);
   root.querySelectorAll('[data-included-gift]').forEach(input=>input.value='BEAM RIVALS Glow Bands — 4-Pack');
   root.querySelector('button[type=submit]').disabled=disabled;
   root.querySelector('[data-buy-label]').textContent=disabled?'CURRENTLY UNAVAILABLE':'BUY NOW';
   document.querySelectorAll('[data-sticky-offer] button').forEach(e=>{e.disabled=disabled;e.querySelector('[data-sticky-label]').textContent=disabled?'UNAVAILABLE':'BUY NOW'});
   const url=new URL(location.href);url.searchParams.set('variant',chosen.value);history.replaceState({},'',url);
  };
  root.querySelectorAll('input[name=id]').forEach(e=>e.addEventListener('change',update));update();
  const zoom=root.querySelector('[data-zoom]');
  if(zoom)zoom.addEventListener('click',()=>{const d=document.querySelector('[data-image-dialog]');d.querySelector('img').src=photos[photoIndex].dataset.photo;d.querySelector('img').alt=photos[photoIndex].dataset.caption||'';d.showModal()});
 });
 scope.querySelectorAll('[data-close-dialog]').forEach(b=>{if(b.dataset.ready)return;b.dataset.ready='true';b.addEventListener('click',()=>b.closest('dialog').close())});
 scope.querySelectorAll('[data-image-dialog]').forEach(d=>{if(d.dataset.ready)return;d.dataset.ready='true';d.addEventListener('click',e=>{if(e.target===d)d.close()})});
 scope.querySelectorAll('[data-modes]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const buttons=[...root.querySelectorAll('[data-mode]')],panel=root.querySelector('[role=tabpanel]');
  const set=(i,animate=true)=>{
   const data=modes[i];
   buttons.forEach((b,j)=>{b.setAttribute('aria-selected',String(i===j));b.tabIndex=i===j?0:-1});
   panel.setAttribute('aria-labelledby',data.id);panel.style.setProperty('--mode-color',data.color);
   panel.querySelector('[data-mode-title]').textContent=data.title;panel.querySelector('[data-mode-kicker]').textContent=data.kicker;panel.querySelector('[data-mode-copy]').textContent=data.copy;panel.querySelector('.mode-scope b').textContent=String(i+1).padStart(2,'0');
   panel.querySelectorAll('[data-mode-shots]').forEach(value=>value.textContent=String(data.shots));
   panel.querySelectorAll('[data-mode-lives]').forEach(value=>value.textContent=String(data.lives));
   panel.querySelectorAll('[data-mode-ammo-pip]').forEach((pip,j)=>pip.classList.toggle('is-active',j<data.shots));
   panel.querySelectorAll('[data-mode-life-pip]').forEach((pip,j)=>pip.classList.toggle('is-active',j<data.lives));
   panel.querySelectorAll('.mode-stat-visual .is-active').forEach((pip,j)=>{
    if(typeof pip.getAnimations==='function')pip.getAnimations().forEach(animation=>animation.cancel());
    if(animate&&!reduce.matches&&typeof pip.animate==='function')pip.animate([{opacity:.4,transform:'translateY(3px)'},{opacity:1,transform:'translateY(0)'}],{duration:320,delay:j*18,easing:'ease-out'});
   });
  };
  buttons.forEach((b,i)=>{b.addEventListener('click',()=>set(i));b.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight'||e.key==='ArrowDown')next=(i+1)%4;if(e.key==='ArrowLeft'||e.key==='ArrowUp')next=(i+3)%4;if(e.key==='Home')next=0;if(e.key==='End')next=3;if(next!==undefined){e.preventDefault();set(next);buttons[next].focus()}})});
  set(Math.max(0,buttons.findIndex(button=>button.getAttribute('aria-selected')==='true')),false);
 });
 scope.querySelectorAll('[data-back-top]').forEach(b=>{if(b.dataset.ready)return;b.dataset.ready='true';b.addEventListener('click',()=>scrollTo({top:0,behavior:reduce.matches?'instant':'smooth'}))});
 scope.querySelectorAll('a[href="#money-back-guarantee"]').forEach(b=>{if(b.dataset.ready)return;b.dataset.ready='true';b.addEventListener('click',()=>{const d=document.getElementById('money-back-guarantee');if(d)d.open=true})});
 scope.querySelectorAll('video').forEach(video=>{if(video.dataset.ready)return;video.dataset.ready='true';video.addEventListener('play',()=>document.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause()}));if('IntersectionObserver' in window){const vi=new IntersectionObserver(entries=>entries.forEach(e=>{if(!e.isIntersecting)video.pause()}),{threshold:0});vi.observe(video)}});
}
let scheduled=false;
function onScroll(){if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{const max=document.documentElement.scrollHeight-innerHeight;document.documentElement.style.setProperty('--scroll',String(max>0?scrollY/max:0));const purchase=document.querySelector('.purchase'),sticky=document.querySelector('[data-sticky-offer]'),footer=document.querySelector('.footer');if(purchase&&sticky)sticky.classList.toggle('is-visible',purchase.getBoundingClientRect().bottom<0&&(!footer||footer.getBoundingClientRect().top>innerHeight-80));scheduled=false})}
init();onScroll();addEventListener('scroll',onScroll,{passive:true});addEventListener('resize',onScroll);document.addEventListener('shopify:section:load',e=>{init(e.target);onScroll()});reduce.addEventListener('change',()=>{if(reduce.matches)document.body.classList.remove('motion-enabled');else reveal(document)});
})();
